import React, { useEffect, useState } from "react";
import { ShieldCheck, CheckCircle2, Clock } from "lucide-react";
import api from "../../lib/api";

export default function MesAssurances() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/insurance/my-subscriptions").then((r) => setSubs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <p className="text-brand-green/60">{subs.length} souscription{subs.length > 1 ? "s" : ""}</p>
      {subs.length === 0 ? (
        <div className="text-center py-16 text-brand-green/50">
          <ShieldCheck className="w-12 h-12 mx-auto mb-3 opacity-40" />
          Vous n'avez pas encore souscrit d'assurance. Rendez-vous sur la Marketplace.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-6">
          {subs.map((s) => (
            <div key={s.id} className="bg-white rounded-2xl p-6 border border-brand-soft">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 rounded-xl bg-brand-soft flex items-center justify-center"><ShieldCheck className="w-6 h-6 text-brand-greenDeep" /></span>
                  <div>
                    <h3 className="font-semibold text-brand-greenDeep">{s.product_name}</h3>
                    <p className="text-xs text-brand-green/50">{s.insurer_name}</p>
                  </div>
                </div>
                {s.status === "Validée" ? (
                  <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-brand-lime/30 text-brand-greenDeep font-semibold"><CheckCircle2 className="w-3.5 h-3.5" /> {s.status}</span>
                ) : (
                  <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-orange-100 text-orange-700 font-semibold"><Clock className="w-3.5 h-3.5" /> {s.status}</span>
                )}
              </div>
              <div className="grid grid-cols-2 gap-3 text-sm mt-4">
                <div><p className="text-brand-green/50 text-xs">Prime annuelle</p><p className="font-semibold text-brand-greenDeep">{s.annual_amount} €</p></div>
                <div><p className="text-brand-green/50 text-xs">Type de bien</p><p className="font-semibold text-brand-greenDeep">{s.property_type}</p></div>
                <div><p className="text-brand-green/50 text-xs">Surface</p><p className="font-semibold text-brand-greenDeep">{s.surface} m²</p></div>
                <div><p className="text-brand-green/50 text-xs">Montant garanti</p><p className="font-semibold text-brand-greenDeep">{s.coverage_amount} €</p></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
